import { render, staticRenderFns } from "./LogAcesso.vue?vue&type=template&id=3431ce2f"
import script from "./LogAcesso.vue?vue&type=script&lang=ts"
export * from "./LogAcesso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports